import { Box, Typography } from '@mui/material';
import SectionLoader from 'components/shared/SectionLoader';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useParams } from 'react-router-dom';
import { BusinessesService } from 'service/businesses.service';
import zeplinColor from 'theme/Color';
import Card from './Card';

const SimilarCompanies = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!id) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        const res = await BusinessesService.getSimilarCompanies(id);
        setData(res.companies.similar);
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  if (loading) return <SectionLoader />;

  return (
    <Box sx={{ display: 'flex', gap: { xs: '20px', xl: '32px' }, height: 'calc(100vh - 350px)' }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,
          height: '100%',
          overflowY: 'auto',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 1,
          }}
        >
          <Typography variant='responsiveHeading3'>Similar companies</Typography>
          <InfiniteScroll
            dataLength={data.length || 0}
            loader={
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <></>
              </Box>
            }
            next={() => {}}
            hasMore={data.length < 12}
            height={'calc(100vh - 350px)'}
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              width: '100%',
            }}
          >
            {!data ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  flex: 1,
                  height: '100%',
                  gap: '32px',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '24px',
                    width: '100%',
                  }}
                >
                  <img src={'/assets/no-zoominfo.svg'} alt='no zoominfo results' />
                  <Typography
                    variant='responsiveHeading3'
                    color={zeplinColor.BasicBlack}
                    sx={{ marginTop: '0px' }}
                  >
                    No similar companies
                  </Typography>
                </Box>
              </Box>
            ) : (
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: {
                    xs: 'repeat(2,1fr)',
                    xl: 'repeat(3,1fr)',
                  },
                  gap: '24px',
                  overflowY: 'auto',
                  gridAutoRows: 'min-content',
                  gridAutoFlow: 'row',
                  flex: 1,
                }}
              >
                {data.map((item: any) => (
                  <Card key={item.id} data={item} />
                ))}
              </Box>
            )}
          </InfiniteScroll>
        </Box>
      </Box>
    </Box>
  );
};

export default SimilarCompanies;
